<template>
    <b-modal title="Грамматика" size="xl" v-model="opts.show" @ok="opts.show = false">
      <template #modal-header="{ close }">
        <h5 class="mr-2">
          Грамматика
        </h5>
        (<b-link :href="tagLink" target="_blank">Расшифровка тегов</b-link>)
        <b-button class="close" @click="close()">×</b-button>
      </template>

      <b-row class="mb-1">
          <b-col>
              <div>{{compiledgr}}</div>
          </b-col>
      </b-row>
      <b-row class="mb-5">
          <b-col>
            <b-button v-if="compiledgr.length>0" @click="clearGrammar">очистить</b-button>
          </b-col>
      </b-row>
      
      <UdmGrammar v-if="langContext == 0" :filter="filter"/>
      <RusGrammar v-if="langContext == 1" :filter="filter"/>
      

      <template #modal-footer="{ ok, cancel }">
        <b-link :href="tagLink" target="_blank">
          Расшифровка тегов
        </b-link>
        <b-button @click="cancel()">
          Cancel
        </b-button>
        <b-button @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>
</template>

<script>

import UdmGrammar from './grammarcomponents/UdmGrammar'
import RusGrammar from './grammarcomponents/RusGrammar'
export default {
  name: "grammarwindow",

  components:{
    UdmGrammar,
    RusGrammar
  },

  mounted() {

  },

  props: {
    opts: {
      type: Object,
      default: null
    },
    filter: {
      type: Object,
      default: null
    },
    corpusType: {
      type: Number,
      default: 0
    }
  },

  data(){
    return {
      
    }
  },

  computed:{
    langContext() {
      if (this.corpusType == 2 && this.filter.chunkType == 0) return 1
      return 0
    },

    tagLink(){
      if (this.langContext == 0) return 'https://udmurt.web-corpora.net'
      if (this.langContext == 1) return 'https://ruscorpora.ru/page/instruction-morph'
    },

    compiledgr(){
      let out = ''

      let len = 0
      for(let key in this.filter.gr) {
        len += this.filter.gr[key].length
      }
      if (len == 0) out = 'Грамматика не выбрана'
      else {

        // for(let key in this.filter.gr) {

        //   if (this.filter.gr[key].length != 0) {
        //     if (out.trim().length != 0) out += ','
        //     let grr = '';
        //     for (let sp of this.filter.gr[key]) {
        //       if (grr.length != 0) grr += '|'
        //       grr+=sp;
        //     }
        //     if (grr.indexOf('|')>-1) out += '('+grr+')';
        //     else out += grr;
        //   }

        // }


        if (this.filter.gr.partOfSpeech.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.partOfSpeech) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.lexicalClasses.length != 0 || this.filter.gr.numerals.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.lexicalClasses) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          
          for (let sp of this.filter.gr.numerals) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.attributivizers.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.attributivizers) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.number.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.number) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.coreCases.length != 0 || this.filter.gr.spatialCases.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.coreCases) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          for (let sp of this.filter.gr.spatialCases) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.spatialCases2.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.spatialCases2) {
            if (grr.length != 0) grr += ','
            grr+=sp;
          }
          out += grr;
        }
        if (this.filter.gr.possessiveness.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.possessiveness) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.tense_mood.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.tense_mood) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.verbalDerivation.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.verbalDerivation) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.nonFiniteForms.length != 0 || this.filter.gr.imperatives.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.nonFiniteForms) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          for (let sp of this.filter.gr.imperatives) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.genus.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.genus) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.animacy.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.animacy) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.shortLongForm.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.shortLongForm) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.degreeOfComparison.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.degreeOfComparison) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.view.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.view) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.transitivity.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.transitivity) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.pledge.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.pledge) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.formOfVerb.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.formOfVerb) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.mood.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.mood) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.time.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.time) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }

        if (this.filter.gr.face.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.face) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        
        if (this.filter.gr.otherSigns.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.otherSigns) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        
      }
      this.filter.compiledgr = out;
      return out;
    }
  },
  methods: {
    clearGrammar(){
      for(let key in this.filter.gr) {
        this.filter.gr[key] = []
      }
    }
  }
}
</script>